import { render, staticRenderFns } from "./MontaggioBobina.vue?vue&type=template&id=76d75773&scoped=true&"
import script from "./MontaggioBobina.vue?vue&type=script&lang=js&"
export * from "./MontaggioBobina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d75773",
  null
  
)

export default component.exports